import {
  BuildYourOwnDesk,
  BuildYourOwnDining,
  BuildYourOwnDiningChair,
  BuildYourOwnDiningTable,
  BuildYourOwnMittzon,
} from "@inter-ikea-byox/build-your-own";

import type { EnvironmentSettings, Experience } from "@inter-ikea-space-platform/experience";

export const buildYourOwnFunctionalPackages = (_settings: EnvironmentSettings): Experience[] => [
  {
    ...BuildYourOwnDesk(),
    enabledOnlyWhen: {
      featureFlagsEnabled: ["byodFunctionalPackage"],
    },
  },
  {
    ...BuildYourOwnDiningTable(),
    enabledOnlyWhen: {
      featureFlagsEnabled: ["byodFunctionalPackage"],
    },
  },
  {
    ...BuildYourOwnDiningChair(),
    enabledOnlyWhen: {
      featureFlagsEnabled: ["byodFunctionalPackage"],
    },
  },
  {
    ...BuildYourOwnDining(),
    enabledOnlyWhen: {
      featureFlagsEnabled: ["byodFunctionalPackage"],
    },
  },
  {
    ...BuildYourOwnMittzon(),
    enabledOnlyWhen: {
      featureFlagsEnabled: ["byodFunctionalPackage"],
    },
  },
];
